"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    gatewayService: ()=>gatewayService,
    GatewayService: ()=>GatewayService
});
const once_namespaceObject = require("lodash/once");
var once_default = /*#__PURE__*/ __webpack_require__.n(once_namespaceObject);
const external_gateway_config_js_namespaceObject = require("./gateway.config.js");
const async_jwt_config_js_namespaceObject = require("../jwt/async-jwt.config.js");
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
const checkValidGatewayItem = (maps, key)=>Object.prototype.hasOwnProperty.call(maps, key);
const checkValidGatewayKey = (maps, key)=>Object.prototype.hasOwnProperty.call(maps, key);
const checkValidDomainID = (maps, key)=>Object.prototype.hasOwnProperty.call(maps, key);
class GatewayService {
    async getGatewayKeyByDomainID(domainID) {
        const gatewayConfig = await this.getGatewayConfig();
        if (checkValidDomainID(gatewayConfig.domainIDToGatewayKey, domainID)) return gatewayConfig.domainIDToGatewayKey[domainID];
    }
    async getDomainIDByGatewayKey(gatewayKey) {
        const gatewayConfig = await this.getGatewayConfig();
        if (checkValidGatewayKey(gatewayConfig.gatewayKeyToDomainID, gatewayKey)) return gatewayConfig.gatewayKeyToDomainID[gatewayKey];
    }
    async getGatewayItemByGatewayKey(gatewayKey) {
        const gatewayConfig = await this.getGatewayConfig();
        if (checkValidGatewayItem(gatewayConfig.gatewayItems, gatewayKey)) return gatewayConfig.gatewayItems[gatewayKey];
    }
    async getJwtUniqueKeyByGatewayKey(gatewayKey) {
        const gatewayConfig = await this.getGatewayConfig();
        if (checkValidGatewayItem(gatewayConfig.gatewayItems, gatewayKey)) {
            const gatewayItem = gatewayConfig.gatewayItems[gatewayKey];
            return gatewayItem.jwtUniqueKey;
        }
    }
    async getTargetGatewayKey(param) {
        let { certainDomainID, certainGatewayKey, defaultDomainID, defaultGatewayKey } = param;
        const gatewayConfig = await this.getGatewayConfig();
        return checkValidGatewayItem(gatewayConfig.gatewayItems, certainGatewayKey) && certainGatewayKey || certainDomainID && await gatewayService.getGatewayKeyByDomainID(certainDomainID) || checkValidGatewayItem(gatewayConfig.gatewayItems, defaultGatewayKey) && defaultGatewayKey || defaultDomainID && await gatewayService.getGatewayKeyByDomainID(defaultDomainID) || void 0;
    }
    async getDefaultRewriteConfig() {
        const gatewayConfig = await this.getGatewayConfig();
        return gatewayConfig.defaultRewriteRules || [];
    }
    async getDowngrade(domainID) {
        const gatewayConfig = await this.getGatewayConfig();
        const downgradeConfig = null == gatewayConfig ? void 0 : gatewayConfig.downgradeConfig;
        return Boolean((null == downgradeConfig ? void 0 : downgradeConfig.all) || (null == downgradeConfig ? void 0 : downgradeConfig[domainID]));
    }
    async getRequiredOGProxyModeHeadersGatewayKeys() {
        const gatewayConfig = await this.getGatewayConfig();
        return gatewayConfig.requiredOGProxyModeHeadersGatewayKeys;
    }
    onConfigChange(config) {
        if ((null == config ? void 0 : config.gatewayItems) && (null == config ? void 0 : config.domainIDToGatewayKey) && (null == config ? void 0 : config.gatewayKeyToDomainID)) this.getGatewayConfig = ()=>Promise.resolve(config);
    }
    constructor(props){
        _define_property(this, "getGatewayConfig", void 0);
        this.getGatewayConfig = props.getGatewayConfig;
    }
}
const gatewayService = new GatewayService({
    getGatewayConfig: once_default()(async ()=>{
        const firstConfig = await (0, external_gateway_config_js_namespaceObject.getGatewayConfigV2)();
        try {
            const { instance: jwtTccProxy } = (0, async_jwt_config_js_namespaceObject.getJwtTccProxy)();
            const { instance: gatewayTccProxy, isProd } = (0, external_gateway_config_js_namespaceObject.getGatewayTccProxy)();
            const safeSetData = (data)=>{
                if ((null == data ? void 0 : data.gatewayItems) && data.domainIDToGatewayKey && data.gatewayKeyToDomainID) {
                    var _gatewayService_onConfigChange;
                    null == gatewayService || null == (_gatewayService_onConfigChange = gatewayService.onConfigChange) || _gatewayService_onConfigChange.call(gatewayService, data);
                }
            };
            jwtTccProxy.on('configChange', async ()=>{
                const data = await (0, external_gateway_config_js_namespaceObject.convertGatewayConfig)(await gatewayTccProxy.getConfig());
                safeSetData(data);
            });
            gatewayTccProxy.on('configChange', async (param)=>{
                let { currentConfig } = param;
                const data = await (0, external_gateway_config_js_namespaceObject.convertGatewayConfig)(currentConfig);
                safeSetData(data);
            });
            if (isProd) {
                var _gatewayTccProxy_broadcastConfig;
                gatewayTccProxy.listenToChannel();
                await (null == (_gatewayTccProxy_broadcastConfig = gatewayTccProxy.broadcastConfig) ? void 0 : _gatewayTccProxy_broadcastConfig.call(gatewayTccProxy));
            }
        } catch (error) {
            console.error(error);
        }
        return firstConfig;
    })
});
exports.GatewayService = __webpack_exports__.GatewayService;
exports.gatewayService = __webpack_exports__.gatewayService;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "GatewayService",
    "gatewayService"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
